module.exports = __webpack_public_path__ + "static/media/slide3.71774c9b.jpg";